import { useState, useEffect } from 'react';
import api from '@/lib/api';

export interface DippyConfig {
  enabled: boolean;
  name: string;
  avatar: 'seedling' | 'robot';
  alert_style: 'speech_bubble' | 'bounce_badge';
  show_tips: boolean;
  show_alerts: boolean;
  poll_interval_seconds: number;
}

const DEFAULTS: DippyConfig = {
  enabled: true,
  name: 'Dippy',
  avatar: 'seedling',
  alert_style: 'speech_bubble',
  show_tips: true,
  show_alerts: true,
  poll_interval_seconds: 30,
};

export function useDippySettings() {
  const [config, setConfig] = useState<DippyConfig>(DEFAULTS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const res = await api.get<{ settings: Record<string, unknown> }>('/admin/settings');
        if (cancelled) return;
        const raw = res.settings?.dippy_config;
        if (raw && typeof raw === 'object') {
          setConfig({ ...DEFAULTS, ...(raw as Partial<DippyConfig>) });
        }
      } catch {
        // Use defaults on error
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, []);

  return { config, loading };
}

export { DEFAULTS as DIPPY_DEFAULTS };
